import { media } from '@simplywallst/ui-core';

import styled from 'styled-components';

export const Header = styled('h2')`
  color: ${({ theme }) => theme.color.charcoal};
  ${({ theme }) => theme.typography.mega}
  font-weight: 700;
  text-align: center;
  margin: ${({ theme }) => `${theme.x6spacePx}px 0 ${theme.x4spacePx}px`};
`;
interface FeatureTableProps {
  tableIndex: number;
}
export const StyledReactMarkdown = styled('div')<FeatureTableProps>`
  color: ${({ theme }) => theme.color.charcoal};
  width: 100%;
  table {
    margin: ${({ theme }) => theme.x1spacePx}px auto;
    width: 96%;
    ${media.lgUp`
      width: 87%;
    `}
    border-collapse: separate;
    border-spacing: ${({ theme }) => theme.x1spacePx}px 0;
    ${media.lgUp`
      border-spacing: ${({ theme }) => theme.x2spacePx}px 0;
    `}
  }
  th {
    &:first-child {
      ${({ theme }) => theme.typography.base}
      font-weight: 500;
      transform: rotate(0);
      width: 55%;
      text-align: left;
      color: ${({ theme }) => theme.color.charcoal};
    }
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    width: 15%;
    min-width: 49px;
    transform: rotate(-45deg);
    padding-bottom: ${({ theme }) => theme.x1spacePx}px;
    ${({ tableIndex }) => tableIndex > 0 && 'color: transparent;'}
    ${media.smUp`
        transform: rotate(0);
        padding: 20px 0 ${({ theme }) => theme.x1spacePx}px;
        border-top-left-radius: ${({ theme }) => theme.x1spacePx}px;
        border-top-right-radius: ${({ theme }) => theme.x1spacePx}px;
        ${({ theme }) => theme.typography.small}
        ${({ tableIndex, theme }) =>
          tableIndex > 0 && `color: ${theme.color.charcoal};`}
        &:nth-child(2) {
          background-color: ${({ theme }) => theme.color.brand02RGBA(0.05)};
        }
        &:nth-child(3) {
          background-color: ${({ theme }) => theme.color.brand02RGBA(0.15)};
        }
        &:nth-child(4) {
          background-color: ${({ theme }) => theme.color.brand02RGBA(0.1)};
        }
      `}
  }
  tr {
    &:first-child {
      td {
        padding-top: ${({ tableIndex, theme }) =>
          tableIndex === 0 ? '35px' : theme.x2spacePx};
        ${media.smUp`
          padding-top: ${({ theme }) => theme.x2spacePx}px;
        `}
        border-top-left-radius: ${({ theme }) => theme.x1spacePx}px;
        border-top-right-radius: ${({ theme }) => theme.x1spacePx}px;
        ${media.smUp`
            border-top-left-radius: 0;
            border-top-right-radius: 0;
          `}
      }
    }
    &:last-child {
      td {
        padding-bottom: ${({ tableIndex }) =>
          tableIndex === 0 ? '30px' : '24px'};
        border-bottom-left-radius: ${({ theme }) => theme.x1spacePx}px;
        border-bottom-right-radius: ${({ theme }) => theme.x1spacePx}px;
      }
    }
  }

  td {
    ${({ theme }) => theme.typography.small}
    padding-top: ${({ tableIndex }) => (tableIndex === 0 ? '20px' : '10px')};
    margin: 0 20px;
    text-align: center;
    line-height: 21px;
    ${media.smUp`
      padding-top: ${({ theme }) => theme.x2spacePx}px;
      line-height: ${({ theme }) => theme.x3spacePx}px;
    `}
    &:first-child {
      background-color: ${({ theme }) => theme.color.white};
      text-align: left;
      span {
        color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
        margin-left: 15px;
        display: block;
      }
    }
    &:nth-child(2) {
      background-color: ${({ theme }) => theme.color.brand02RGBA(0.05)};
    }
    &:nth-child(3) {
      background-color: ${({ theme }) => theme.color.brand02RGBA(0.15)};
    }
    &:nth-child(4) {
      background-color: ${({ theme }) => theme.color.brand02RGBA(0.1)};
    }
  }
`;
